export default {
  'pages.common.save': 'সংরক্ষণ',
  'pages.common.cancel': 'বাতিল',
  'pages.common.confirm': 'ঠিক আছে',
  'pages.common.ok': 'ঠিক আছে',
  'pages.common.delete': 'মুছুন',
  'pages.common.edit': 'সম্পাদনা',
  'pages.common.add': 'যোগ করুন',
  'pages.common.append': 'যোগ করুন',
  'pages.common.search': 'খুঁজুন',
  'pages.common.reset': 'রিসেট',
  'pages.common.submit': 'জমা দিন',
  'pages.common.back': 'ফিরে যান',
  'pages.common.close': 'বন্ধ',
  'pages.common.export': 'এক্সপোর্ট',
  'pages.common.import': 'ইমপোর্ট',
  'pages.common.refresh': 'রিফ্রেশ',
  'pages.common.detail': 'বিস্তারিত',
  'pages.common.copy': 'কপি',
  'pages.common.operation': 'অপারেশন',
  'pages.common.view': 'দেখুন',
  'pages.common.download': 'ডাউনলোড',
  'pages.common.upload': 'আপলোড',
  'pages.common.yes': 'হ্যাঁ',
  'pages.common.no': 'না',
  'pages.common.loading': 'লোড হচ্ছে…',
  'pages.common.more': 'আরও',
  'pages.common.all': 'সব',
  'pages.common.createSuccess': 'সফলভাবে যোগ হয়েছে',
  'pages.common.saveSuccess': 'সংরক্ষিত',
  'pages.common.deleteSuccess': 'মুছে ফেলা হয়েছে',
  'pages.common.deleteFailed': 'মুছতে ব্যর্থ',
  'pages.common.saveFailed': 'সংরক্ষণ ব্যর্থ',
  'pages.common.loadFailed': 'লোড ব্যর্থ',
  'pages.common.requiredField': 'এই ঘর পূরণ করতে হবে',
  'pages.common.selectedCount': '{count} টি নির্বাচিত',
  'pages.common.clearSelection': 'নির্বাচন সাফ করুন',
  'pages.common.totalRecords': 'মোট {total} টি রেকর্ড',
  'pages.common.batchDeleteCount': 'একসাখে মুছুন ({count})',
  'pages.common.statusSuccess': 'সফল',
  'pages.common.statusFailed': 'ব্যর্থ',
  'pages.common.timeRangeStart': 'শুরুর সময়',
  'pages.common.timeRangeEnd': 'শেষ সময়',
  'pages.common.unnamed': 'নামহীন',
  'pages.common.operationFailedRetry': 'অপারেশন ব্যর্থ। আবার চেষ্টা করুন।',
  'pages.common.batchDeleteSuccess': 'একসাখে মুছে ফেলা সফল',
  'pages.common.batchDeleteFailed': 'একসাখে মুছতে ব্যর্থ। আবার চেষ্টা করুন।',
  'pages.common.nItemsFailed': '{count} টি ব্যর্থ',
  'pages.common.enable': 'Enable',
  'pages.common.disable': 'Disable',
  'pages.common.statusNormal': 'Active',
  'pages.common.statusDisabled': 'Disabled',
  'pages.common.selectOrganization': 'Select organization',
  'pages.common.batchDeleteTitle': 'Confirm batch delete',
  'pages.common.downloadingTemplate': 'Downloading template…',
  'pages.common.templateDownloadSuccess': 'Template downloaded',
  'pages.common.templateDownloadFailed': 'Download failed. Please try again.',
};
